import Vue from 'vue'
import {auth, db} from '../firebase'
import router from '../router'

export default {
    namespaced: true,
    state: {
        user: null,
        allows: []
    },
    mutations: {
        setUser(state, user){
            state.user = user
        },
        setAllows(state, allows){
            state.allows = allows
        }
    },
    actions: {
        checkAuth({commit}){
            auth.onAuthStateChanged((user)=>{
                commit('setUser', user)
            })    
        },
        async doLogin(context, {email, password}){
            try{
                await auth.signInWithEmailAndPassword(email, password)
            }catch(error){
                Vue.$toast.error(error)
            }
        },
        doLogout(){
            auth.signOut()
            router.push({name: 'Home'})
        },
        async getAllows({state, commit}){
            const allows = await db.collection('users').doc(state.user.uid).get()
            commit('setAllows', allows.data())
        },
    },
  }
  